import React from 'react'
import { EmptyState } from '../../shared/empty-state/empty-state'
import { IconShield } from '../../shared/icon/icon'

// What a gated route shows to someone who reached it (a typed URL, a
// bookmark, an old link) without the permission it needs.
export const NoAccess = ({ what = 'this page' }) =>
  <div className="p-3">
    <EmptyState
      Icon={IconShield}
      title="No access"
      message={`You don't have permission to see ${what}. Ask a super admin if you need it.`}
    />
  </div>
